import './MediaComp.css';
import { useEffect, useContext, useState, ChangeEvent, useRef } from 'react';
import { AudienceContext } from '../../../context/AudienceContext';
import {
  formatDate, getClassNameMCNav, renderFaIconsCheckPlus, getMediaCompLocalStorage, setMediaCompLocalStorage
} from './MediaCompUtils';
import { getDataObjArray, loadHoursCalendar, loadMinutesCalendar } from '../Sidebar/SideBarUtils';
import { IndiceContext } from '../../../context/IndiceContext';
import { useTranslation } from 'react-i18next';
import { MiniStyledLabelMC, StyledLabelMC } from '../Sidebar/StyledComponents';
import { DayPicker } from 'react-day-picker';
import i18n from '../../../i18n';
import { es, ptBR, enUS } from "date-fns/locale";
import { IMediaC } from '../../../context/types';
import { GetArrayDataCollectionListMC, GetArrayDataMC } from '../../../utils/arrayHelperList';
import { MediaCompRow } from "./MediaCompRow";
import { MediaCompRowFirst } from "./MediaCompRowFirst";
import { UiContext } from "../../../context/UiContext";

function MediaComp() {
  function getHeaderWidth() {
    if (document.getElementsByClassName("headerFirst").length > 0) {
      let firstHeaderComponent = document.getElementsByClassName("headerFirst")[0];
      let firstHeaderWidth = parseFloat(firstHeaderComponent !== undefined ? getComputedStyle(firstHeaderComponent).width : '0');
      return firstHeaderWidth;
    }
    else if (document.getElementsByClassName("Media_headerFirst").length > 0) {
      let firstHeaderComponent = document.getElementsByClassName("Media_headerFirst")[0];
      let firstHeaderWidth = parseFloat(firstHeaderComponent !== undefined ? getComputedStyle(firstHeaderComponent).width : '0');
      return firstHeaderWidth;
    } else {
      let firstHeaderWidth = window.innerWidth * 20 / 100;
      return firstHeaderWidth;
    }
  }
  function getRowWidth() {
    if (document.querySelector("#divTableMinuteRight tbody") != null) {
      let divTableMinuteRightComponent = document.querySelector("#divTableMinuteRight tbody") ?? undefined;
      let divTableMinuteRightWidth = parseFloat(divTableMinuteRightComponent !== undefined ? getComputedStyle(divTableMinuteRightComponent).width : '0');
      return divTableMinuteRightWidth;
    }
    else if (document.querySelector("#divTableMediaRight tbody") != null) {
      let divTableMediaRightComponent = document.querySelector("#divTableMediaRight tbody") ?? undefined;
      let divTableMediaRightWidth = parseFloat(divTableMediaRightComponent !== undefined ? getComputedStyle(divTableMediaRightComponent).width : '0');
      return divTableMediaRightWidth;
    } else {
      let rowWidth = window.innerWidth * 80 / 100;
      return rowWidth;
    }
  }
  const { isMobile, updateElementRects } = useContext(UiContext);



  let firstHeaderWidth = getHeaderWidth();
  let divTableMinuteRightWidth = getRowWidth();

  const { doAudienceMediaComp, doUpdateMediaComp, audienceMediaCompFirstTable } = useContext(AudienceContext);
  const { indice } = useContext(IndiceContext)
  const [sidebar, setSidebar] = useState<string>("");
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [minuteIniSelect, setMinuteIniSelect] = useState<any>();
  const [hourIniSelect, setHourIniSelect] = useState<any>();
  const [minuteFimSelect, setMinuteFimSelect] = useState<any>();
  const [hourFimSelect, setHourFimSelect] = useState<any>();
  const [indiceSelect, setIndiceSelect] = useState<string>();
  const [autoUpdateSelect, setAutoUpdateSelect] = useState<boolean>();
  const [isVisibleSelect, setisVisibleSelect] = useState<boolean>(true);
  const [sumIndice, setSumIndice] = useState<number>(0);
  const autoUpdateTimerRef = useRef<NodeJS.Timeout | null>(null);

  type ParamGet = {
    paramIndice?: number | string;
    paramData?: string;
  };

  let hoursCalendar: string[] = [],
    minutesCalendar: string[] = [];
  hoursCalendar = loadHoursCalendar();
  minutesCalendar = loadMinutesCalendar();
  //Ajustar automatico de acordo com a largura da tela
  const [widthPage, setWidthPage] = useState(window.innerWidth);
  function updateWidth() {
    setWidthPage(window.innerWidth);
  }

  window.addEventListener("resize", updateWidth);


  useEffect(() => {

  }, [widthPage]);
  useEffect(() => {
  });
  useEffect(() => {
    loadAudienceMediaComp();
  }, []);

  // Cleanup timer quando componente é desmontado
  useEffect(() => {
    return () => {
      if (autoUpdateTimerRef.current) {
        clearInterval(autoUpdateTimerRef.current);
      }
    };
  }, []);
  useEffect(() => {
    if (document.querySelector('#minuteGraphic') != null || document.querySelector('#DivMedComp') != null)
      updateElementRects(document.querySelector('#minuteGraphic'), document.querySelector('#DivMedComp'));
  }, [autoUpdateSelect]);

  function loadAudienceMediaComp(showGrid = true) {
    reloadAudienceMediaComp(showGrid);
    reloadHeaderMC();

  }
  async function reloadAudienceMediaComp(showGrid = true) {
    let MCLocalStorage = getMediaCompLocalStorage();
    if (MCLocalStorage?.autoUpdate) {
      let paramGet: ParamGet = {};
      let strData: string = MCLocalStorage.data ?? '';
      let strHora: string = MCLocalStorage.minutos == undefined ? '' : MCLocalStorage.minutos.split('-')[0];
      paramGet.paramData = (new Date(strData).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replaceAll('/', '-')) + " " + strHora;
      if (MCLocalStorage.codIndice != null) {
        paramGet.paramIndice = MCLocalStorage.codIndice;
      }
      else {
        paramGet.paramIndice = (MCLocalStorage.indice != null ? indice.find(item => item.Desc === MCLocalStorage?.indice).Id : '');
      }
      await doAudienceMediaComp(paramGet.paramData, paramGet.paramIndice);
      reloadHeaderMC();
      setisVisibleSelect(showGrid);
    }
    else {
      if (showGrid) {
        await doAudienceMediaComp("", "");
      }
      setisVisibleSelect(showGrid);
    }
    updateElementRects(document.querySelector('#minuteGraphic'), document.querySelector('#DivMedComp'));

  }

  function initilizeAudienceMediaTimer(force: boolean | undefined) {
    // Limpa timer anterior se existir
    if (autoUpdateTimerRef.current) {
      clearInterval(autoUpdateTimerRef.current);
      autoUpdateTimerRef.current = null;
    }

    if (force) {
      autoUpdateTimerRef.current = setInterval(TimerAutoUpdate, 30000);
    }
  }
  function reloadHeaderMC() {
    let MCLocalStorage = getMediaCompLocalStorage();
    if (MCLocalStorage != null) {
      let McLs: IMediaC = MCLocalStorage;
      let dtDataMC: string = McLs.data ?? new Date().toDateString();
      if (McLs.indice && McLs.indice !== indiceSelect) {
        setIndiceSelect(McLs.indice);
      }
      if (typeof McLs.codIndice === 'number' && McLs.codIndice !== sumIndice) {
        setSumIndice(McLs.codIndice);
      }
      setSelectedDate(new Date(dtDataMC));
      setHourIniSelect(McLs.minutos?.split('-')[0].split(':')[0]);
      setMinuteIniSelect(McLs.minutos?.split('-')[0].split(':')[1]);
      setHourFimSelect(McLs.minutos?.split('-')[1].split(':')[0]);
      setMinuteFimSelect(McLs.minutos?.split('-')[1].split(':')[1]);
      setAutoUpdateSelect(McLs.autoUpdate);
      initilizeAudienceMediaTimer(McLs.autoUpdate);
    }
  }
  function SaveHeadersMC(autoUpdate: boolean | null, data: string | null, indice: string | null, codIndice: number | null, minutos: string | null) {
    let MCLocalStorage = getMediaCompLocalStorage();
    if (MCLocalStorage != null) {
      let McLs: IMediaC = MCLocalStorage
      if (autoUpdate != null) {
        McLs.autoUpdate = autoUpdate;
      }
      if (data != null) {
        McLs.data = data;
      }
      if (indice != null) {
        McLs.indice = indice;
      }
      if (codIndice != null) {
        McLs.codIndice = codIndice;
      }
      if (minutos != null) {
        McLs.minutos = minutos;
      }
      setMediaCompLocalStorage(McLs);
      reloadHeaderMC();
    }

  }
  function TimerAutoUpdate() {
    reloadAudienceMediaComp();
    reloadHeaderMC();
  }
  //#region INDICE

  let PriDesc;
  let SecDesc;
  let combPri;
  let combSec;
  let combIndice;


  if (indice !== undefined && sumIndice !== undefined) {
    combIndice = ComboIndice();
    combPri = ComboPri();
    combSec = ComboSec();
  }
  function ComboIndice() {
    let arrayBoundIndice = indice.filter(filterIndiceCombo).map(a => a.Desc)
    return arrayBoundIndice;
  }
  function filterIndiceCombo(elIndice) {
    return elIndice.Desc;
  }
  const TrocaIndice = event => {
    let indiceSelected = indice.filter(x => x.Desc === event.target.value)[0];
    setIndiceSelect(event.target.value);
    SaveHeadersMC(null, null, event.target.value, indiceSelected.Id, null)
    setSumIndice(indiceSelected.Id);
    combPri = ComboPri();
    combSec = ComboSec();
  }
  function calcIndice() {
    let newIndice = 0;
    newIndice = indice.filter(filterIndice)[0].Id;
    return newIndice;
  }


  function filterIndice(elIndice) {
    if (SecDesc === "-") {
      return elIndice.Desc === PriDesc;
    }
    else {
      return elIndice.Desc === (PriDesc + "-" + SecDesc);
    }
  }
  function changeIndice(newIndice: number) {
    setSumIndice(newIndice);
    let indiceObj = indice.filter(x => x.Id === newIndice)[0];

    let DescGeral = indiceObj.Desc;
    setIndiceSelect(DescGeral);
    SaveHeadersMC(null, null, DescGeral, newIndice, null)
  }
  function ComboPri() {
    let indiceObj = indice.filter(x => x.Id === sumIndice)[0];
    PriDesc = indiceObj.Desc?.split('-')[0];
    SecDesc = indiceObj.Desc?.split('-').length > 1 ? indiceObj.Desc.split('-')[1] : '-';

    let arrayBoundPri = indice.filter(filterPriCombo).map(a => a.Desc)
    return arrayBoundPri;
  }
  function filterPriCombo(elIndice) {
    return elIndice.Desc.split('-').length === 1;
  }
  function ComboSec() {
    let arrayBoundSec = indice.filter(filterSecCombo).map(a => a.Desc.split('-')[1])
    arrayBoundSec.unshift('-')
    return arrayBoundSec;
  }
  function filterSecCombo(elIndice) {
    return elIndice.Desc.split('-').length > 1 && elIndice.Desc.split('-')[0] === PriDesc;
  }
  const TrocaPri = event => {
    let OldDesc = PriDesc;
    PriDesc = event.target.value;
    if (OldDesc != PriDesc) {
      SecDesc = "-"
      let newIndice = calcIndice()
      changeIndice(newIndice);
    }
  }
  const TrocaSec = event => {
    let OldDesc = SecDesc;
    SecDesc = event.target.value;
    if (OldDesc != SecDesc) {
      let newIndice = calcIndice()
      changeIndice(newIndice);
    }
  }
  //#endregion
  //#region PERIODO

  function controlNavBar(component: string) {
    component !== sidebar ? setSidebar(component) : setSidebar("");
  }
  function getLanguageDaypiker() {
    let lang;
    switch (i18n?.language?.toUpperCase()) {
      case "pt-BR".toUpperCase():
        lang = ptBR;
        break;
      case "es-ES".toUpperCase():
        lang = es;
        break;
      case "en-US".toUpperCase():
        lang = enUS;
        break;
      default:
        lang = enUS;
        break;
    }
    return lang;
  }
  const
    hourFimChange = (event) => {
      setHourFimSelect(event.target.value);
      let strMinutes: string = "";
      strMinutes = hourIniSelect + ":" + minuteIniSelect + "-" + event.target.value + ":" + minuteFimSelect;
      SaveHeadersMC(null, null, null, null, strMinutes)
    };
  const minutesFimChange = (event) => {
    setMinuteFimSelect(event.target.value);
    let strMinutes: string = "";
    strMinutes = hourIniSelect + ":" + minuteIniSelect + "-" + hourFimSelect + ":" + event.target.value;
    SaveHeadersMC(null, null, null, null, strMinutes)
  };
  const hourIniChange = (event) => {
    setHourIniSelect(event.target.value);
    let strMinutes: string = "";
    strMinutes = event.target.value + ":" + minuteIniSelect + "-" + hourFimSelect + ":" + minuteFimSelect;
    SaveHeadersMC(null, null, null, null, strMinutes)
  };
  const minutesIniChange = (event) => {
    setMinuteIniSelect(event.target.value);
    let strMinutes: string = "";
    strMinutes = hourIniSelect + ":" + event.target.value + "-" + hourFimSelect + ":" + minuteFimSelect;
    SaveHeadersMC(null, null, null, null, strMinutes)
  };

  const handleSelectDate = (day) => {
    if (day != undefined) {
      setSelectedDate(day);
      let MCLocalStorage = getMediaCompLocalStorage();
      if (MCLocalStorage) {
        let McLs: IMediaC = MCLocalStorage;
        McLs.data = day.toISOString();
        setMediaCompLocalStorage(McLs);
      }
    }
  };
  const navHora = (
    <nav id="hora"
      style={{ left: "50%", marginLeft: "-150px" }}
      className={getClassNameMCNav(sidebar, "hora")}
    >
      <header>
        <h1>{t("secret.rows.secondTable")}</h1>
        <button style={{ top: '10px' }}
          onClick={() => controlNavBar("")}>
          {t("settings.close")}
        </button>
        <button style={{ marginLeft: '84%', top: '10px' }}
          onClick={() => handleOnClickCheckPlus(isAutoUpdate())}>
          {t("settings.save")}
        </button>
      </header>


      <ul className="nav-mc-default">
        <div style={{ display: 'flex', margin: "10px" }}>
          <label style={{ fontSize: "16px", fontWeight: "400", margin: "5px" }}>{t("settings.autoUpdate")}</label>
          <StyledLabelMC htmlFor="checkboxMC" checked={isAutoUpdate()} >
            <input
              id="checkboxMC"
              type="checkbox"
              checked={isAutoUpdate()}
              onChange={handleOnChangeMini}
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "12px",
                backgroundColor: "#69df00",
                display: "inline-block",
                marginLeft: "20px"
              }}
            />
          </StyledLabelMC>
        </div>
      </ul>

      <h2 className="realtime">{t("secret.vars.title")}</h2>
      <ul className="nav-mc-default">
        <div style={{ display: 'flex', marginLeft: "10px" }}>
          <li className={'indice-div-mc'}>
            <label>{t("secret.vars.input1")}</label>
            <select name="comboPri" value={PriDesc} onChange={TrocaPri}>
              {getDataObjArray(combPri).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}
            </select>
          </li>
          <li className={'indice-div-mc'}>
            <label>{t("secret.vars.input2")}</label>
            <select className='indice-combo' name="comboSec" value={SecDesc} onChange={TrocaSec}>
              {getDataObjArray(combSec).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}
            </select>
          </li>
        </div>
      </ul>
      <div className={!isAutoUpdate() ? "" : "nav-menu-mc-hidden"}>
        <h2 className="realtime">{t("rows.date")}</h2>
        <ul className="nav-menu-hora" >
          <div style={{ marginLeft: "-10px" }}>
            <div className="DayPicker-NavBar">
              <span className="DayPicker-NavButton DayPicker-NavButton--prev"></span>
              <span className="DayPicker-NavButton DayPicker-NavButton--next"></span>
            </div>
            <DayPicker
              id="DayPMedia"
              mode="single"
              selected={selectedDate}
              onSelect={handleSelectDate}
              showOutsideDays={true}
              disabled={(day) => day > new Date()}
              weekStartsOn={0}
              locale={getLanguageDaypiker()

              }
            />
          </div>
        </ul>
      </div>
      <h2 className="realtime">{t("rows.startingTime")}</h2>
      <ul className="nav-menu-hour-minute">
        <div className="selectDivMinute">
          <div className="selectEndMinute">
            <label>{t("rows.hour")}</label>
            <select onChange={hourIniChange} style={{ width: "100%" }}>
              {getDataObjArray(hoursCalendar).map((option) =>
                hourIniSelect === option.DataValueArray ? (
                  <option
                    selected
                    value={option.DataValueArray}
                    key={option.ValueId}
                  >
                    {option.DataValueArray}
                  </option>
                ) : (
                  <option
                    value={option.DataValueArray}
                    key={option.ValueId}
                  >
                    {option.DataValueArray}
                  </option>
                )
              )}
            </select>
          </div>
          <div className="selectEndMinute">
            <label>{t("rows.minute")}</label>
            <select onChange={minutesIniChange} style={{ width: "100%" }}>
              {getDataObjArray(minutesCalendar).map((option) =>
                minuteIniSelect === option.DataValueArray ? (
                  <option
                    selected
                    value={option.DataValueArray}
                    key={option.ValueId}
                  >
                    {option.DataValueArray}
                  </option>
                ) : (
                  <option
                    value={option.DataValueArray}
                    key={option.ValueId}
                  >
                    {option.DataValueArray}
                  </option>
                )
              )}
            </select>
          </div>
        </div>
      </ul>


      <div className={!isAutoUpdate() ? "" : "nav-menu-mc-hidden"}>
        <h2 className="realtime">{t("rows.endingTime")}</h2>
        <ul className="nav-menu-hour-minute">
          <div className="selectDivMinute">
            <div className="selectEndMinute">
              <label>{t("rows.hour")}</label>
              <select onChange={hourFimChange} style={{ width: "100%" }}>
                {getDataObjArray(hoursCalendar).map((option) =>
                  hourFimSelect === option.DataValueArray ? (
                    <option
                      selected
                      value={option.DataValueArray}
                      key={option.ValueId}
                    >
                      {option.DataValueArray}
                    </option>
                  ) : (
                    <option
                      value={option.DataValueArray}
                      key={option.ValueId}
                    >
                      {option.DataValueArray}
                    </option>
                  )
                )}
              </select>
            </div>
            <div className="selectEndMinute">
              <label>{t("rows.minute")}</label>
              <select onChange={minutesFimChange} style={{ width: "100%" }}>
                {getDataObjArray(minutesCalendar).map((option) =>
                  minuteFimSelect === option.DataValueArray ? (
                    <option
                      selected
                      value={option.DataValueArray}
                      key={option.ValueId}
                    >
                      {option.DataValueArray}
                    </option>
                  ) : (
                    <option
                      value={option.DataValueArray}
                      key={option.ValueId}
                    >
                      {option.DataValueArray}
                    </option>
                  )
                )}
              </select>
            </div>
          </div>
        </ul>
      </div>
    </nav >
  )

  const MinuteMenu = () => {
    const autoUpdateActived = isAutoUpdate();

    const conditionalInputStyles = {
      opacity: autoUpdateActived ? "0.5" : "1",
      cursor: autoUpdateActived ? "not-allowed" : "pointer"
    };

    const periodoInputStyle = {
      width: "80px",
      ...conditionalInputStyles
    };

    const horaFimInputStyle = {
      ...conditionalInputStyles
    };

    return (
      <div id='divminuteMC' style={{ display: 'flex', alignItems: 'center' }}>
        {!isMobile && (
          <>
            <div id="divPeriodo" style={{ marginLeft: '10px', marginRight: '10px' }}>
              <label htmlFor="dtPeriodoMC" style={{ color: 'white', marginRight: '10px' }}>{t("rows.range")}</label>
            </div>
            <input
              id="dtPeriodoMC"
              type='text'
              readOnly
              disabled={autoUpdateActived}
              style={periodoInputStyle}
              onClick={() => controlNavBar("hora")}
              value={formatDate(selectedDate)}
            />
            <span
              className="icon-calendar"
              style={{ fontSize: "17px", marginRight: "5%", marginLeft: "10px" }}>
            </span>
            <input
              id="dtHoraIniMC"
              placeholder="HH:mm"
              type='text'
              readOnly
              onClick={() => controlNavBar("hora")}
              value={hourIniSelect + ':' + minuteIniSelect}
            />
            <label htmlFor="dtHoraIniMC"
              style={{ fontSize: '20px', fontWeight: '400', color: 'white', padding: '2px' }}>-</label>
            <input
              id="dtHoraFimMC"
              placeholder="HH:mm"
              type='text'
              readOnly
              disabled={autoUpdateActived}
              style={horaFimInputStyle}
              onClick={() => controlNavBar("hora")}
              value={hourFimSelect + ':' + minuteFimSelect}
            />
          </>
        )}
        <button
          onClick={() => {
            if (isMobile) {
              controlNavBar("hora")
            } else {
              handleOnClickCheckPlus(autoUpdateActived);
            }
          }}
          className='btn-icons-mc'
        >
          <span id="CheckPlusIcon" className="iconCheckPlus">
            {renderFaIconsCheckPlus(autoUpdateActived)}
          </span>
        </button>
      </div>
    );
  };
  //#endregion
  //#region AUTOUPDATE
  function isAutoUpdate(): boolean {
    return Boolean(autoUpdateSelect);
  }

  async function handleOnClickCheckPlus(AutoUpdateOnOff: boolean) {
    controlNavBar("");
    if (AutoUpdateOnOff) {
      //check
      reloadAudienceMediaComp();
    } else {
      //plus
      SaveHeadersMC(AutoUpdateOnOff,
        selectedDate != undefined ? selectedDate.toISOString() : '',
        indiceSelect ?? '',
        indiceSelect != undefined ? indice.find(item => item.Desc === indiceSelect).Id : sumIndice,
        hourIniSelect + ":" + minuteIniSelect + "-" + hourFimSelect + ":" + minuteFimSelect)
      let gridVisible = true;
      await doUpdateMediaComp(indiceSelect != undefined ? indice.find(item => item.Desc === indiceSelect).Id : sumIndice,
        selectedDate?.toISOString().split("T")[0], hourIniSelect + ":" + minuteIniSelect, hourFimSelect + ":" + minuteFimSelect, AutoUpdateOnOff, 'A').then((res) => {
          gridVisible = true;
        }).catch((err) => {
          gridVisible = isVisibleSelect
        });

      loadAudienceMediaComp(gridVisible);
    }
  }

  function handleOnChangeMini(e: ChangeEvent<HTMLInputElement>) {
    changeAutoUpdate(!isAutoUpdate(), isAutoUpdate());

  }
  async function changeAutoUpdate(
    checkedCurrent: boolean,
    checkedBefore: boolean
  ) {
    if (checkedCurrent) {
      await doUpdateMediaComp(null, null, null, null, checkedCurrent, null);
      SaveHeadersMC(checkedCurrent,
        selectedDate != undefined ? selectedDate.toISOString() : '',
        indiceSelect ?? '',
        sumIndice,
        hourIniSelect + ":" + minuteIniSelect + "-" + hourFimSelect + ":" + minuteFimSelect)
      reloadAudienceMediaComp();
    }
    else {
      setisVisibleSelect(false);

    }
    setAutoUpdateSelect(checkedCurrent);
    SaveHeadersMC(checkedCurrent, null, null, null, null)
  }
  //#endregion

  //#region   GRID
  function GetIndiceCod(IndiceDesc: string) {
    if (IndiceDesc === undefined || indice === undefined) {
      return null;
    }
    let IndiceCod = indice.find(item => item.Desc === IndiceDesc).Id;
    return IndiceCod;
  }
  async function handleRowDelete(keyDelete: string) {
    let KeyMC = keyDelete.split("|");
    let indiceaverage = KeyMC[0];
    let dataaverage = KeyMC[1];
    let horainiaverage = KeyMC[2];
    let horafimaverage = KeyMC[3];
    let autoupdate = false
    let mcaction = "D"


    await doUpdateMediaComp(indiceaverage, dataaverage, horainiaverage, horafimaverage, autoupdate, mcaction)
    loadAudienceMediaComp();
  }

  const gridMC = (
    <div id="divMediaCompBoth" style={{
      overflow: "hidden",
      display: "flex",
    }}>
      <div
        id="divMediaCompLeft"
        data-testid="divMediaCompLeft"
        style={{
          width: firstHeaderWidth + "px",
          float: "left"
        }}
      >
        <table
          style={{
            width: "100%"
          }}
        >
          <tbody>
            {GetArrayDataCollectionListMC(audienceMediaCompFirstTable)?.map(
              (rowContent, rowID) => (
                <MediaCompRowFirst
                  rowContent={rowContent.Data}
                  rowID={rowContent.dataID}
                  key={rowContent.dataID}
                  Indice={GetIndiceCod(rowContent.Data[1])}
                  onDelete={handleRowDelete}
                  isAutoUpdate={isAutoUpdate()}
                />
              )
            )}
          </tbody>
        </table>
      </div>
      <div
        id="divMediaCompRight"
        data-testid="divMediaCompRight"
        style={{
          width: window.innerWidth - firstHeaderWidth + "px",
          float: "left",
          overflow: "hidden",
          whiteSpace: 'nowrap'
        }}
      >
        <table
          style={{
            width: divTableMinuteRightWidth,
          }}
        >
          <tbody>
            {GetArrayDataMC(audienceMediaCompFirstTable).map((rowContent, rowID) => (
              <MediaCompRow
                rowContent={rowContent.Data}
                rowID={rowContent.dataID}
                key={rowContent.dataID}
                Indice={GetIndiceCod(rowContent.Data[1])}
                dataFormatada={rowContent.Data[3]}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )

  useEffect(() => {
    const handleDisableElements = () => {
      const tableRows = document.querySelectorAll('#divMediaCompRight .tableRow').length / 2;
      const toolbarElements = document.querySelectorAll('#secondTableToolbarCenter input, #secondTableToolbarCenter button, #secondTableToolbarCenter select');
      toolbarElements.forEach(element => {
        if (element instanceof HTMLInputElement || element instanceof HTMLButtonElement || element instanceof HTMLSelectElement) {
          element.disabled = tableRows >= 5;
        }
      });
    };

    window.addEventListener("resize", handleDisableElements);
    handleDisableElements();

    return () => {
      window.removeEventListener("resize", handleDisableElements);
    };
  }, [audienceMediaCompFirstTable]);

  useEffect(() => {
    if (sidebar === "hora" && indiceSelect && Array.isArray(indice)) {
      let indiceObj = indice.filter(x => x.Desc === indiceSelect)[0];
      if (indiceObj !== null && indiceObj.Id !== sumIndice) {
        setSumIndice(indiceObj.Id);
      }
    }
  }, [sidebar, indiceSelect, indice]);

  return (
    <div id="divMediaCComponent" data-testid="divMediaCComponent" style={{ width: '100%', position: 'relative', top: '15px' }}>
      {isMobile ? (
        <>
          <div id="secondTableContent" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {isVisibleSelect && gridMC}
          </div>
          <div id="secondTableToolbar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: "rgba(255,255,255,0.2)" }}>
            <div id="secondTableToolbarLeft"
              style={{ display: isMobile ? 'none' : 'flex', verticalAlign: 'middle' }}>
              <span id={'secondTabtleToolbarTitle'}
                style={{ color: '#389D97', marginLeft: 10, whiteSpace: 'nowrap' }} >
                {t("secret.rows.secondTable")}
              </span>
            </div>
            <div id="secondTableToolbarCenter" style={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle', fontSize: 12, textAlign: 'center' }}>
              <div data-testid="divIndice" style={{ display: isMobile ? 'none' : 'flex', marginRight: '3pc' }}>
                <label style={{ color: 'white', marginRight: '10px' }}>{t("secret.vars.title")}</label>
                <select name="comboIndice" className="combo-indice" value={indiceSelect} onChange={TrocaIndice}>
                  {getDataObjArray(combIndice).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}
                </select>
              </div >
              {MinuteMenu()}
            </div>
            <div id="secondTableToolbarRight">
              <label style={{ marginRight: '10', color: 'white', textTransform: 'uppercase', display: 'flex', alignItems: 'center', paddingRight: '20px' }}>{t("settings.autoUpdateStatus")}
                <MiniStyledLabelMC htmlFor="checkboxMiniMC" checked={isAutoUpdate()}>
                  <input
                    id="checkboxMiniMC"
                    type="checkbox"
                    checked={isAutoUpdate()}
                    onChange={handleOnChangeMini}

                  />
                </MiniStyledLabelMC>
              </label>
            </div>
          </div>
        </>
      ) : (
        <>
          <div id="secondTableToolbar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: "rgba(255,255,255,0.2)" }}>
            <div id="secondTableToolbarLeft"
              style={{ display: isMobile ? 'none' : 'flex', verticalAlign: 'middle' }}>
              <span id={'secondTabtleToolbarTitle'}
                style={{ color: '#389D97', marginLeft: 10, whiteSpace: 'nowrap' }} >
                {t("secret.rows.secondTable")}
              </span>
            </div>
            <div id="secondTableToolbarCenter" style={{ display: 'flex', alignItems: 'center', verticalAlign: 'middle', fontSize: 12, textAlign: 'center' }}>
              <div data-testid="divIndice" style={{ display: isMobile ? 'none' : 'flex', marginRight: '3pc' }}>
                <label style={{ color: 'white', marginRight: '10px' }}>{t("secret.vars.title")}</label>
                <select name="comboIndice" className="combo-indice" value={indiceSelect} onChange={TrocaIndice}>
                  {getDataObjArray(combIndice).map(val => <option value={val.DataValueArray} key={val.ValueId}>{val.DataValueArray}</option>)}
                </select>
              </div >
              {MinuteMenu()}
            </div>
            <div id="secondTableToolbarRight">
              <label style={{ marginRight: '10', color: 'white', textTransform: 'uppercase', display: 'flex', alignItems: 'center', paddingRight: '20px' }}>{t("settings.autoUpdateStatus")}
                <MiniStyledLabelMC htmlFor="checkboxMiniMC" checked={isAutoUpdate()}>
                  <input
                    id="checkboxMiniMC"
                    type="checkbox"
                    checked={isAutoUpdate()}
                    onChange={handleOnChangeMini}
                  />
                </MiniStyledLabelMC>
              </label>
            </div>
          </div>
          <div id="secondTableContent" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {isVisibleSelect && gridMC}
          </div>
        </>
      )}
      {navHora}
    </div>
  );
}
export default MediaComp;
